import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 24px;
    cursor: pointer;
  `,
  header: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: ${colors.prussian};
  `,
  title: css`
    height: 100%;
    color: ${colors.prussian};
    font-size: 14px;
  `,
  amount: css`
    font-size: 14px;
    color: ${colors.slate};
  `,
  flyer: css`
    width: 78px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    padding: 4px 10px 10px 16px;
    width: 100%;
  `,
  footer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    /* margin-top: 8px; */
    font-size: 13px;
    color: ${colors.prussian};
  `,
};

export default styles;
